module.exports = __webpack_public_path__ + "static/media/knownoriginv2-back.5b42e56f.svg";